import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */

export const HandIcon = ({ title = 'Hand', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.982 10.752l6.113-6.113m0 0l1.111-1.11c.556-.371 1.334-.89 2.223 0 .889.888.37 1.851 0 2.222l-6.668 6.668 5-5.001c.4-.4 1.46-.764 2.224 0 .677.677.555 1.667 0 2.222l-6.113 6.113 4.445-4.446c.371-.37 1.334-.889 2.223 0 .89.89.37 1.853 0 2.223-2.408 2.593-4.863 5.176-8.335 7.78-2.223 1.667-6.668 0-8.335-1.668-1.963-1.962-2.102-3.932-1.667-6.112.556-2.778 2.964-7.409 4.445-9.446 1.334.889 1.667 2.222 1.112 3.334l-1.112 2.778 7.224-7.78c.556-.555 1.667-.555 2.223 0 .738.739.321 1.902 0 2.223z"
      stroke="#505050"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default HandIcon;
